// frontend/src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const brand = {
  purple: "#6D5EF9",
  purpleTint: "#F3F0FF",
  purpleBorder: "#E7E2FF",
  neutralText: "#111827",
  neutralBorder: "#E5E7EB",
  muted: "#6B7280",
  gradient: "linear-gradient(135deg, #1E3A8A 0%, #6D28D9 100%)",
};

export default function Footer() {
  return (
    <footer className="site-footer">
      <StyleTag />
      <div className="foot-inner">
        <div className="foot-left">
          <div className="foot-brand">ArtiBytes</div>
          <div className="foot-small">
            © {new Date().getFullYear()} ArtiBytes. All rights reserved.
          </div>
        </div>

        <nav className="foot-nav">
          <Link to="/terms" className="grad-btn">Terms</Link>
          <Link to="/privacy" className="grad-btn">Privacy</Link>
          <Link to="/content-policy" className="grad-btn">Content Policy</Link>

          {/* Contact as an envelope icon (keeps gradient) */}
          <a
            href="mailto:jaytayeldev@gmail.com"
            rel="noreferrer"
            className="grad-btn grad-btn--icon"
            aria-label="Contact"
            title="Contact"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v.01L12 13l8-6.99V6H4zm16 12V8l-8 6-8-6v10h16z"
                fill="currentColor"
              />
            </svg>
          </a>
        </nav>
      </div>
    </footer>
  );
}

function StyleTag() {
  return (
    <style>{`
.site-footer{
  border-top:1px solid ${brand.neutralBorder};
  background:#fff;
  margin-top:36px;
  width:100%;
}
.foot-inner{
  max-width:1100px;
  margin:0 auto;
  padding:14px 16px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}
.foot-brand{ font-weight:900; color:${brand.neutralText}; }
.foot-small{ color:${brand.muted}; font-size:12px; margin-top:2px; }

.foot-nav{
  display:flex; gap:14px; flex-wrap:wrap;
}

/* Unified gradient buttons (default / desktop) */
.grad-btn{
  color:#fff;
  text-decoration:none;
  font-weight:800;
  border:none;
  padding:8px 14px;
  border-radius:999px;
  background:${brand.gradient};
  box-shadow:0 6px 16px rgba(109,94,249,.22);
  transition: transform .12s ease, box-shadow .12s ease, opacity .12s ease;
  display:inline-flex; align-items:center; justify-content:center;
  line-height:1;
}
.grad-btn:hover{
  transform: translateY(-1px);
  box-shadow:0 10px 22px rgba(109,94,249,.28);
}
.grad-btn:active{
  transform: translateY(0);
  opacity:.95;
}

/* Icon-only gradient button (envelope) – default desktop size */
.grad-btn--icon{
  width:38px; height:38px; padding:0; /* circular */
}
.grad-btn--icon svg{ display:block; }

/* ===== Mobile tweaks: make the pills smaller ===== */
@media (max-width: 720px){
  .foot-inner{
    flex-direction:column;
    align-items:flex-start;
    gap:10px;
  }
  .foot-nav{
    gap:10px;
  }
  .grad-btn{
    font-size:13px;         /* smaller text */
    padding:6px 10px;       /* tighter padding */
    box-shadow:0 4px 12px rgba(109,94,249,.18);
  }
  .grad-btn--icon{
    width:32px;             /* smaller circle */
    height:32px;
  }
  .grad-btn--icon svg{
    width:16px; height:16px; /* smaller glyph */
  }
}

/* Extra small phones */
@media (max-width: 380px){
  .foot-nav{ gap:8px; }
  .grad-btn{ font-size:12.5px; padding:6px 9px; }
  .grad-btn--icon{ width:30px; height:30px; }
}
    `}</style>
  );
}